namespace Matrix.Data {
    export class AccountValueColumns {
        static columnsKey = 'Data.AccountValue';
    }
}
